module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "back-list page"
  }, [_vm._m(0), _vm._v(" "), _c('z-scrollDiv', {
    staticClass: "main"
  }, [_vm._l((_vm.dataList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "list-item"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("justDate")(item.bill_time)))]), _vm._v(" "), _c('div', {
      class: {
        add: item.bill_type == 1, reduce: item.bill_type != 1
      }
    }, [_vm._v(_vm._s(item.amount && (item.bill_type == 1 ? "+" : "-") + item.amount))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.balance))]), _vm._v(" "), _c('div', {
      staticClass: "overhide"
    }, [_vm._v(_vm._s(item.remark))])])
  }), _vm._v(" "), _c('z-noData', {
    attrs: {
      "list": _vm.dataList
    }
  })], 2)], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.data.current_page,
      "total": _vm.data.total,
      "page-size": _vm.data.per_page,
      "layout": "prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.search,
      "update:currentPage": function($event) {
        _vm.$set(_vm.data, "current_page", $event)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-head"
  }, [_c('div', [_vm._v("日期")]), _vm._v(" "), _c('div', [_vm._v("职级增减")]), _vm._v(" "), _c('div', [_vm._v("职级级别")]), _vm._v(" "), _c('div', [_vm._v("备注")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-e95ddf22!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/person-detail/tab/person-rank.vue
// module id = 793
// module chunks = 1